"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=holiday.dto.js.map